import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import subDays from 'date-fns/subDays';
import { format } from 'date-fns';
import DataTable from '../common/DataTable';
import SelectBox from '../common/SelectBox';
import Input from '../common/Input';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaSearch } from 'react-icons/fa';
import { IoMdList } from 'react-icons/io';
import { MainContext } from './MainContext';
import Loading from '../common/Loading';

const RequestHistory = () => {
   const { requests, fetchRequests, fetchRequestsByMeter, loadingRequest } = useContext(MainContext);
   const [startDate, setStartDate] = useState(subDays(new Date(), 0));
   const [endDate, setEndDate] = useState(new Date());
   const [searchValue, setSearchValue] = useState('');
   const [searchKey, setSearchKey] = useState({});
   const [items, setItems] = useState([]);
   const [filterValue, setFilterValue] = useState('');
   const [currentData, setCurrentData] = useState([]);

   console.log(loadingRequest);

   let pageSize = 50;
   const options = [
      { value: '', label: 'Select' },
      { value: 'mobile', label: 'By Mobile' },
      { value: 'meter', label: 'By Meter' },
   ];

   let columns = [
      {
         columnCaption: 'Transaction Id',
         columnKey: 'transactionId',
         type: 'text',
         content: (item) => <Link to={`/RequestHistoryDetails/${item.transactionId}`}>{item.transactionId}</Link>,
      },
      {
         columnCaption: 'Phone Number',
         columnKey: 'buyerIdentifier',
      },
      {
         columnCaption: 'Input',
         columnKey: 'userInput',
      },
      {
         columnCaption: 'Reply',
         columnKey: 'responseText',
      },
      {
         columnCaption: 'Time',
         columnKey: 'createdAt',
      },
   ];

   const onRequestPage = () => {
      if (requests.length > 0) {
         setCurrentData(requests);
         setItems(uniqByKeepFirst(requests, (it) => it.transactionId));
      }
   };

   useEffect(onRequestPage, []);

   useEffect(onRequestPage, [loadingRequest]);

   const uniqByKeepFirst = (a, key) => {
      let seen = new Set();
      let filteredItems = a.filter((item) => {
         let k = key(item);
         return seen.has(k) ? false : seen.add(k);
      });
      filteredItems.sort((x, y) => {
         if (x.createdAt < y.createdAt) {
            return 1;
         }
         if (x.createdAt > y.createdAt) {
            return -1;
         } else {
            return 0;
         }
      });
      return filteredItems;
   };

   const onSearch = (e) => {
      e.preventDefault();
      let value = e.target.value;
      setFilterValue(value);
      let searchItems = [...currentData];
      let filteredItems = searchItems.filter((dataItem) => {
         return (
            dataItem.buyerIdentifier.includes(value) ||
            dataItem.transactionId.includes(value) ||
            dataItem.userInput.includes(value) ||
            dataItem.responseText.includes(value) ||
            dataItem.createdAt.includes(value)
         );
      });
      setItems(filteredItems);
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      let formatedStartDate = format(startDate, 'yyyy-MM-dd');
      let formatedEndDate = format(endDate, 'yyyy-MM-dd');
      if (!searchKey.value) {
         toast.error('Select search by criteria');
         return;
      } else {
         if (searchKey.value === 'mobile') {
            fetchRequests(formatedStartDate, formatedEndDate, searchKey.value, searchValue);
         } else {
            fetchRequestsByMeter(formatedStartDate, formatedEndDate, searchKey.value, searchValue);
         }
      }
   };

   return (
      <>
         <div className='container-fluid'>
            <div className='row'>
               <div className='col-md-6 offset-md-2'>
                  <form className='form' onSubmit={handleSubmit}>
                     <div className='form-row align-items-center'>
                        <div className='form-group custom-form-group col-md-3'>
                           <label htmlFor='startDate'>StartDate</label>
                           <Input
                              type='date'
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              dateFormat='dd/MM/yyyy'
                              id='startDate'
                              className='form-control form-control-sm custom-input'
                           />
                        </div>
                        <div className='form-group custom-form-group col-md-3'>
                           <label htmlFor='endDate'>End Date</label>
                           <Input
                              type='date'
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              dateFormat='dd/MM/yyyy'
                              id='endDate'
                              className='form-control form-control-sm custom-input'
                           />
                        </div>
                     </div>
                     <div className='form-row'>
                        <div className='form-group col-md-3'>
                           <SelectBox
                              label='Search By'
                              getOptionLabel={({ label }) => label}
                              getOptionValue={({ value }) => value}
                              value={searchKey}
                              options={options}
                              onChange={(selected) => setSearchKey(selected)}
                              placeholder={'Search By ...'}
                           />
                        </div>
                        <div className='form-group col-md-6'>
                           <input
                              type='text'
                              className='form-control form-control-sm'
                              placeholder='Search Value'
                              id='phoneNumber'
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                           />
                        </div>
                     </div>
                     <Button type='submit' className={`btn btn-sm text-white `} disabled={loadingRequest}>
                        <FaSearch /> Search
                     </Button>
                  </form>
               </div>
            </div>
            <div className='row mt-2'>
               <div className='col-md-8 offset-md-2'>
                  {loadingRequest ? (
                     <div className='d-flex justify-content-center align-items-center'>
                        <Loading loading={loadingRequest} />
                     </div>
                  ) : (
                     <div className=''>
                        <form className='form-inline justify-content-end'>
                           <div className='input-group input-group-sm mb-2 mr-sm-2'>
                              <div className='input-group-prepend'>
                                 <div className='input-group-text'>
                                    <IoMdList />
                                 </div>
                              </div>
                              <Input
                                 name='searchBox'
                                 type='text'
                                 className='form-control custom-input'
                                 id='searchBox'
                                 value={filterValue}
                                 placeholder=''
                                 onChange={onSearch}
                              />
                           </div>
                        </form>
                        <div className='table-responsive'>
                           <DataTable items={items} pageSize={pageSize} rowKey={'transactionId'} columns={columns}></DataTable>
                        </div>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </>
   );
};

export default RequestHistory;
